import { SectionFieldDeclaration, visibleFieldDeclarations } from '@workbuddy/ui/v2/surface.engine/core/sections/wb.section.component';
import { SectionRenderInfo } from '@workbuddy/ui/v2/surface.engine/core/surface/surface.section.render.info';

// Each delivery section is one column, so the block lines up under the party cards above it.
// The host stretches the last row, which keeps both columns ending on the same line.
export interface FinancialDocumentDeliveryColumn {
  readonly path: string;
  readonly columns: number;
  readonly rows: readonly (readonly SectionFieldDeclaration[])[];
}

export function financialDocumentDeliveryColumns(sections: readonly SectionRenderInfo[]): FinancialDocumentDeliveryColumn[] {

  return sections
    .map(info => ({ path: info.section.path, columns: info.section.columns, rows: financialDocumentDeliveryRows(visibleFieldDeclarations(info.fields), info.section.columns) }))
    .filter(column => column.rows.length > 0);
}

/** Packs fields into rows of `columns` cells. A colspan wider than the row is clamped to the row. */
export function financialDocumentDeliveryRows(fields: readonly SectionFieldDeclaration[], columns: number): SectionFieldDeclaration[][] {

  const rows: SectionFieldDeclaration[][] = [];
  let used = columns;
  for (const field of fields) {
    const span = Math.min(Math.max(field.colspan ?? 1, 1), columns);
    if (used + span > columns) {
      rows.push([]);
      used = 0;
    }
    rows[rows.length - 1].push(field);
    used += span;
  }
  return rows;
}
